import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useAmplitudeEmbedCodeMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/x/updateAnalyticsEmbedCode',
    method: 'POST'
  })
}
